import MagicLogin from './component';

export default MagicLogin;

